module.exports = __webpack_public_path__ + "img/auth.466ac67f.jpg";